/** Matches mobile `CompetitorListScreen` logo name matching (public URLs). */
const COMPETITOR_LOGO_PATHS: Record<string, string> = {
    mica: '/competitor-logos/mica.png',
    builders: '/competitor-logos/builders.png',
    buco: '/competitor-logos/buco.png',
    'build it': '/competitor-logos/build_it.png',
    chamberlains: '/competitor-logos/chamberlains.png',
    'leroy merlin': '/competitor-logos/leroy_merlin.png',
};

export function getCompetitorLogoSrc(name: string): string | undefined {
    const key = Object.keys(COMPETITOR_LOGO_PATHS).find(competitorKey =>
        name.toLowerCase().includes(competitorKey),
    );
    return key ? COMPETITOR_LOGO_PATHS[key] : undefined;
}

/** Same logic as mobile `getCompanyInitials` in CompetitorListScreen. */
export function getCompanyInitials(companyName: string): string {
    const words = companyName.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) {
        return '?';
    }
    if (words.length > 1) {
        return `${words[0][0]}${(words[words.length - 1] ?? ' ')[0]}`;
    }
    return words[0][0];
}
